module.exports = __webpack_public_path__ + "static/small-diamond-mob-81865a95adc70c826f5c103b782473cd.png";